import { Language } from '@data/utils/enums';

/**
 * Single source of truth for how a pre-localised link carries its language:
 * a `lang` query param, read back by useDetectLanguage on the landing page.
 */
export const setLanguageParam = (url: string, language: Language): string => {
  const parsed = new URL(url);
  parsed.searchParams.set('lang', language);
  return parsed.toString();
};
